module.exports = __webpack_public_path__ + "img/CJDR.8774d5ea.jpg";